import { createContext } from 'react';
import { magicLinkContextDefaultValue } from './magic-link';
export var userContextDefaultValue = {
    ctaServerMaintenance: undefined,
    systemInfo: undefined,
    user: undefined,
    user2: undefined,
    magicLinkContext: magicLinkContextDefaultValue,
    selectedWallet: undefined,
    localWalletAddress: undefined,
    balances: undefined,
    fees: undefined,
    reconnectUser: function () { return Promise.resolve(); },
    getBalances: function () { return Promise.resolve(); },
    setSelectedWallet: function (_address) { return undefined; },
    addLocalWallet: function (_address) { return undefined; },
    removeLocalWallet: function () { return undefined; },
};
export var UserContext = createContext(userContextDefaultValue);
